import moment from 'moment';
import template from './am-operator-view.html';

class AmOperatorViewController {
  constructor(amOperatorsService, amStoreService, usersService, $stateParams, $state) {
    'ngInject';

    this.opService = amOperatorsService;
    this.usersService = usersService;
    this.store = amStoreService;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.status = '';
    this.editMode = '';
    this.onLoadErrorFlag = false;
    this.editName = '';
    this.editAttrs = {};
  }

  $onInit() {
    this.operator = this.store.viewedOperator;
    this.getOperatorData(this.$stateParams.id);
    this.setTab = 'codes';
  }

  $onChanges() {}

  $onDestroy() {}

  getOperatorData(id) {
    this.status = 'loading';
    this.opService
      .getOperatorById(id)
      .then((operator) => {
        this.status = '';
        this.operator = operator;
        this.editName = operator.name;
        this.editAttrs = { ...operator.attrs };
        this.onLoadErrorFlag = false;
        this.checkIPAFExpiry();
      })
      .catch(() => {
        this.status = 'error';
        this.onLoadErrorFlag = true;
      });
  }

  showEditForm() {
    this.editMode = true;
  }

  cancelEdit() {
    this.editMode = false;
    this.editName = this.operator.name;
    this.editAttrs = { ...this.operator.attrs };
  }

  checkIPAFExpiry() {
    if (
      this.usersService.hasRequiredFeatures(['access.operator_expiry']) &&
      this.operator.codes.types.includes('IPAF')
    ) {
      const ipaf = this.operator.codes.accessCodes.filter((code) => code.type === 'IPAF')[0]
        .accessCard.label;
      if (ipaf) {
        this.opService.getOperatorExpiryById(ipaf).then((expiry) => {
          const newExpiry = moment(moment.utc(expiry.expires).format('L'));
          const currentExpiry = moment(this.operator.attrs.expiry);
          if (newExpiry.isAfter(currentExpiry)) {
            this.editAttrs.expiry = newExpiry;
            this.editAttrs.isIPAFExpiry = true;
            this.updateOperatorMetaData(this.operator.name, {
              ...this.operator.attrs,
              expiry: newExpiry,
            });
          }
        });
      }
    }
  }

  updateOperatorMetaData(name, attrs) {
    if (!name) return;
    this.update_status = 'updating';
    this.opService
      .updateOperatorMetaData(this.operator.id, name, attrs)
      .then((updatedOperator) => {
        this.update_status = '';
        this.operator.name = updatedOperator.name;
        this.operator.attrs = updatedOperator.attrs;
        this.cancelEdit();
      })
      .catch(() => {
        this.update_status = 'error';
      });
  }

  confirmThenDelete() {
    this.opService
      .openDeleteOperatorPopup(this.operator)
      .then(() => {
        // delete done successfully go back to the operators list;
        this.$state.go('access-management.operators-list');
      })
      .catch(() => {});
  }

  updateCodes(newCodes) {
    this.operator.codes = newCodes;
  }

  updateAssets(totalAssets) {
    this.operator.equipment.total_Assignments = totalAssets;
  }
}

export default {
  template,
  controller: AmOperatorViewController,
  controllerAs: 'opVm',
  bindings: {},
};
